/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { safeFilterActions } from '@zcode/utils'
import { sitemapReducer } from './reducers'
import { whitelist } from './whitelist'

export const sitemap = safeFilterActions(sitemapReducer, whitelist)
